<template>
  <svg height="16" viewBox="0.5 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5,15.5 c1.13,0,2.198-0.268,3.144-0.744" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
    <path d="M3.306,13.193 c0.616,0.682,1.365,1.242,2.206,1.639" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
    <path d="M1.5,8.5 c0,0.881,0.163,1.724,0.46,2.5" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
    <path
      d="M13.797,13.076 C14.858,11.849,15.5,10.25,15.5,8.5c0-3.866-3.134-7-7-7c-2.636,0-4.828,1.641-6,4"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <polyline fill="none" points="2.5,0.5 2.5,5.5 7.5,5.5 " stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
  </svg>
</template>
